export var Actions;
(function (Actions) {
    Actions["ITEM_CLICKED"] = "recommendation/ITEM_CLICKED";
    Actions["NAVIGATION_NEXT"] = "recommendation/NAVIGATION_NEXT";
    Actions["NAVIGATION_PREV"] = "recommendation/NAVIGATION_PREV";
})(Actions || (Actions = {}));
